import { Component, OnInit, EventEmitter, Input, OnDestroy, Output, ViewEncapsulation } from "@angular/core";
import { Page, IUserAccount } from "../../models";
import { takeUntil, finalize } from "rxjs/operators";
import { LabBillHeaderModel } from "../../../areas/admin/labs/pages/models";
import { ApiResources, MoneyHelper } from "../../helpers";
import { AppData, HttpService, PrintOptionService } from "../../services";

@Component({
    templateUrl: "./investigation-exclusions.html",
    selector: "investigation-invoice",
    encapsulation: ViewEncapsulation.None
})

export class InvestigationWidget implements OnInit, OnDestroy {
    @Input() newLabBookingHeaderId: number;
    @Input() encryptedNewLabBookingHeaderId: string;
    @Output() onClose = new EventEmitter<any>();
    page: Page;
    loading: boolean;
    QrCode: string = null;
    currentDate: Date;
    bill: Array<LabBillHeaderModel>;
    isPrintLogo: boolean;
    constructor(
        private readonly appData: AppData,
        private readonly httpService: HttpService,
        private readonly printOptionService: PrintOptionService,
    ) {
        this.page = new Page();
        //this.age = new Age();
        this.bill = new Array<LabBillHeaderModel>();
        this.currentDate = new Date();

    }

    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    this.fetchInvoice();
                    this.printOptionService.get((is) => { this.isPrintLogo = is; });
                } else {
                    this.page.userAccount = undefined;
                    this.fetchInvoice();
                    this.printOptionService.get((is) => { this.isPrintLogo = is; });
                }
            });
    }

    ngOnDestroy() {
        this.page.unsubscribeAll();
    }

    onCloseModal() {
        this.onClose.emit();
    }

    private fetchInvoice() {
        const request = {
            encryptedNewLabBookingHeaderId: this.encryptedNewLabBookingHeaderId
        };
        this.loading = true;
        this.httpService.post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchInvestigationreport), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe(
                (response: Array<LabBillHeaderModel>) => {
                    this.bill = response;
                    this.moneyHelper();
                   
                });
        this.currentDate = new Date();
       
    }
    moneyHelper = () => {
        this.bill[0].overallTotalAmountInWord = MoneyHelper.numberCurrencyIn(this.bill[0].overallNetAmount);
 }
     
    overallTotalAmount
    onChangePrintType(type: boolean) {
        this.isPrintLogo = type;
    }
}